export const filterLocations = [
  "North America",
  "United States",
  "San Francisco Bay Area",
  "New York",
  "Boston",
  "Austin",
  "Seattle",
  "Los Angeles",
  "Chicago",
  "Atlanta",
  "Denver",
  "San Diego",
  "Canada",
  "Central and South America",
  "Mexico",
  "Brazil",
  "Argentina",
  "Chile",
  "Colombia",
  "Peru",
  "Europe",
  "United Kingdom",
  "London",
  "Germany",
  "Berlin",
  "France",
  "Paris",
  "Spain",
  "Barcelona",
  "Benelux",
  "Belgium",
  "Netherlands",
  "Luxemburg",
  "Amsterdam",
  "Northern Europe",
  "Sweden",
  "Finland",
  "Denmark",
  "Norway",
  "Iceland",
  "Ireland",
  "Switzerland",
  "Portugal",
  "Estonia",
  "Latvia",
  "Poland",
  "Italy",
  "Austria",
  "Asia",
  "China",
  "Beijing",
  "Shanghai",
  "Shenzhen",
  "India",
  "Bangalore",
  "Mumbai",
  "Delhi",
  "Japan",
  "South Korea",
  "Singapore",
  "Israel",
  "Tel Aviv",
  "Hong Kong",
  "Pakistan",
  "SE Asia",
  "Indonesia",
  "Thailand",
  "Vietnam",
  "Middle East & Africa",
  "Turkey",
  "Saudi Arabia",
  "United Arab Emirates",
  "South Africa",
  "Kenya",
  "Nigeria",
  "Oceania",
  "Australia",
  "New Zealand"
];

export const nonUItypes = ["description", "lastFundingDate", "group"];

export const typesCompressionMap = {
  tag: "tag",
  location: "loc",
  financialStage: "fs",
  funding: "fund",
  foundingYear: "foundingY",
  lastFundingDate: "lastFund",
  description: "desc",
  lastFundingYear: "lastFundY",
  group: "g"
};

export const inverseTypesCompressionMap = {
  tag: "tag",
  loc: "location",
  fs: "financialStage",
  fund: "funding",
  foundingY: "foundingYear",
  lastFund: "lastFundingDate",
  desc: "description",
  lastFundY: "lastFundingYear",
  g: "group"
};
